//@flow
import React from 'react';

import {Edit, InfoOutlined} from '@material-ui/icons';
import {IconButton, Tooltip} from '@material-ui/core';

import ProductNameCell from '../components/ProductRow/ProductCells/ProductNameCell';
import ProductFeatureCell from '../components/ProductRow/ProductCells/ProductFeaturedCell';
import SizeGuideCell from '../components/ProductRow/ProductCells/SizeGuideCell';
import ProductDescriptionCell from '../components/ProductRow/ProductCells/ProductDescriptionCell';
import ProductVideoCell from '../components/ProductRow/ProductCells/ProductVideoCell';
import ProductPriceCell from '../components/ProductRow/ProductCells/ProductPriceCell';
import ProductTaxedPriceCell from '../components/ProductRow/ProductCells/ProductTaxedPriceCell';
import ProductOfferPriceCell from '../components/ProductRow/ProductCells/ProductOfferPriceCell';
import ProductTaxedOfferPriceCell from '../components/ProductRow/ProductCells/ProductTaxedOfferPriceCell';
import ProductStockCell from '../components/ProductRow/ProductCells/ProductStockCell';
import CategoryCell from '../components/ProductRow/ProductCells/CategoryCell';
import SubCategoryCell from '../components/ProductRow/ProductCells/SubCategoryCell';
import SubCategoryItemCell from '../components/ProductRow/ProductCells/SubCategoryItemCell';
import TaxesCell from '../components/ProductRow/ProductCells/TaxesCell';
import PromotionCell from '../components/ProductRow/ProductCells/PromotionsCell';
import WholesalePriceCell from '../components/ProductRow/ProductCells/WholesalePriceCell';
import FaqCell from '../components/ProductRow/ProductCells/FaqCell';
import SimilarProductsCell from '../components/ProductRow/ProductCells/SimilarProductsCell';
import SeoCell from '../components/ProductRow/ProductCells/SeoCell';
import ProductSkuCell from '../components/ProductRow/ProductCells/ProductSkuCell';

import VariantCombinationCell from '../components/ProductRow/ProductVariantCells/VariantCombinationCell';
import VariantImageCell from '../components/ProductRow/ProductVariantCells/VariantImageCell';
import VariantOffButtonCell from '../components/ProductRow/ProductVariantCells/VariantOffButtonCell';
import VariantOfferPriceCell from '../components/ProductRow/ProductVariantCells/VariantOfferPriceCell';
import VariantPriceCell from '../components/ProductRow/ProductVariantCells/VariantPriceCell';
import VariantSkuCell from '../components/ProductRow/ProductVariantCells/VariantSkuCell';
import VariantStockCell from '../components/ProductRow/ProductVariantCells/VariantStockCell';
import VariantWholesalePriceCell from '../components/ProductRow/ProductVariantCells/VariantWholesalePriceCell';
// import AddWholesalePriceButtonIcon from '../components/AddWholesalePriceButtonIcon';
// import WholesalePriceOptionCell from '../components/ProductRow/ProductCells/WholesalePriceOptionCell';
import ProductVideoTooltip from '../components/ProductVideoTooltip';
import VariantStockSwitchAdornment from '../components/VariantStockSwitchAdornment';
import VariantCombinationSwitchAdornment from '../components/VariantCombinationSwitchAdornment';
import VariantTaxedPriceCell from '../components/ProductRow/ProductVariantCells/VariantTaxedPriceCell';
import VariantTaxedOfferPriceCell from '../components/ProductRow/ProductVariantCells/VariantTaxedOfferPriceCell';

export type TableCell = {
  id: string,
  Header: string | Function,
  headerLabel: string | Function,
  disabled?: boolean,
  headerLabel?: string,
  HeaderLeftAdornment?: Function,
  CellComponent: any,
  disabledMinimal?: boolean,
};

const PRODUCT_TABLE_CELLS: TableCell[] = [
  {
    id: 'name',
    Header: 'Nombre de producto',
    headerLabel: 'Nombre de producto',
    CellComponent: ProductNameCell,
  },
  {
    id: 'video-link',
    Header: 'Link de video',
    headerLabel: 'Link de video',
    CellComponent: ProductVideoCell,
    HeaderLeftAdornment: ProductVideoTooltip,
  },
  {
    id: 'sku',
    Header: 'SKU',
    headerLabel: 'SKU',
    CellComponent: ProductSkuCell,
  },
  {
    id: 'price',
    Header: 'Valor de venta',
    headerLabel: 'Valor de venta',
    CellComponent: ProductPriceCell,
  },
  {
    id: 'taxed-price',
    Header: 'Precio de venta',
    headerLabel: 'Precio de venta',
    CellComponent: ProductTaxedPriceCell,
  },
  {
    id: 'offerPrice',
    Header: 'Valor de oferta',
    headerLabel: 'Valor de oferta',
    CellComponent: ProductOfferPriceCell,
  },
  {
    id: 'taxed-offerPrice',
    Header: 'Precio de oferta',
    headerLabel: 'Precio de oferta',
    CellComponent: ProductTaxedOfferPriceCell,
  },
  {
    id: 'wholesale-price',
    Header: 'Precio Mayorista',
    headerLabel: 'Precio Mayorista',
    CellComponent: WholesalePriceCell,
    disabledMinimal: true,
    // HeaderLeftAdornment: AddWholesalePriceButtonIcon,
  },
  {
    id: 'category',
    Header: 'Categoría',
    headerLabel: 'Categoría',
    CellComponent: CategoryCell,
  },
  {
    id: 'subcategory',
    Header: 'Subcategoría',
    headerLabel: 'Subcategoría',
    CellComponent: SubCategoryCell,
    HeaderLeftAdornment: () => (
      <Tooltip
        title="Solo puede seleccionar una subcategoría por cada categoría"
        arrow
        placement="top"
      >
        <IconButton>
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    id: 'subcategoryitem',
    Header: 'Items de Subcategoría',
    headerLabel: 'Items de Subcategoría',
    CellComponent: SubCategoryItemCell,
    HeaderLeftAdornment: () => (
      <Tooltip
        title="Solo puede seleccionar items de subcategorías activas"
        arrow
        placement="top"
      >
        <IconButton>
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    id: 'description',
    Header: 'Descripción',
    headerLabel: 'Descripción',
    CellComponent: ProductDescriptionCell,
  },
  {
    id: 'features',
    Header: 'Características destacadas',
    headerLabel: 'Características destacadas',
    CellComponent: ProductFeatureCell,
  },
  {
    id: 'stock',
    Header: 'Stock',
    headerLabel: 'Stock',
    CellComponent: ProductStockCell,
    disabledMinimal: true,
  },

  {
    id: 'promotions',
    Header: 'Promociones',
    headerLabel: 'Promociones',
    HeaderLeftAdornment: () => (
      <Tooltip title="Editar en la página de Promociones" arrow placement="top">
        <IconButton>
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
    CellComponent: PromotionCell,
  },

  {
    id: 'similar-products',
    Header: 'Productos similiares',
    headerLabel: 'Productos similiares',
    CellComponent: SimilarProductsCell,
  },
  {
    id: 'seo',
    Header: 'SEO',
    headerLabel: 'SEO',
    CellComponent: SeoCell,
  },
  {
    id: 'faq',
    Header: 'Preguntas frecuentes',
    headerLabel: 'Preguntas frecuentes',
    disabled: true,
    CellComponent: FaqCell,
  },
  {
    id: 'taxes',
    Header: 'Impuestos',
    headerLabel: 'Impuestos',
    disabled: true,
    HeaderLeftAdornment: () => (
      <Tooltip title="Editar en la página de Impuestos" arrow>
        <IconButton>
          <Edit fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
    CellComponent: TaxesCell,
    disabledMinimal: true,
  },
  {
    id: 'size-guide',
    Header: 'Guía de tallas',
    headerLabel: 'Guía de tallas',
    disabled: true,
    CellComponent: SizeGuideCell,
  },
];

export const TABLE_CELLS: TableCell[] = PRODUCT_TABLE_CELLS.filter(
  cell => !cell.disabled
);

export type VariantIds =
  | 'variants'
  | 'sku'
  | 'price'
  | 'offerPrice'
  | 'wholesale-price'
  | 'combinations'
  | 'stock'
  | 'enabled';

export const FIXED_VARIANT_TABLE_CELLS: string[] = [
  'variants',
  'combinations',
  'enabled',
];

export const VARIANT_TABLE_CELLS: TableCell[] = [
  {
    id: 'variants',
    Header: 'Variantes',
    headerLabel: 'Variantes',
    CellComponent: VariantImageCell,
  },
  {
    id: 'sku',
    Header: 'SKU',
    headerLabel: 'SKU',
    CellComponent: VariantSkuCell,
  },
  {
    id: 'price',
    Header: 'Valor de venta',
    headerLabel: 'Precio',
    CellComponent: VariantPriceCell,
  },
  {
    id: 'taxed-price',
    Header: 'Precio de venta',
    headerLabel: 'Precio de venta',
    CellComponent: VariantTaxedPriceCell,
  },
  {
    id: 'offerPrice',
    Header: 'Valor de oferta',
    headerLabel: 'Valor de oferta',
    CellComponent: VariantOfferPriceCell,
  },
  {
    id: 'taxed-offerPrice',
    Header: 'Precio de oferta',
    headerLabel: 'Precio de oferta',
    CellComponent: VariantTaxedOfferPriceCell,
  },
  {
    id: 'wholesale-price',
    Header: 'Precio Mayorista',
    headerLabel: 'Precio Mayorista',
    CellComponent: VariantWholesalePriceCell,
  },
  {
    id: 'combinations',
    Header: 'Combinaciones',
    headerLabel: 'Combinaciones',
    CellComponent: VariantCombinationCell,
    HeaderLeftAdornment: VariantCombinationSwitchAdornment,
  },
  {
    id: 'stock',
    Header: 'Stock',
    headerLabel: 'Stock',
    CellComponent: VariantStockCell,
    HeaderLeftAdornment: VariantStockSwitchAdornment,
  },
  {
    id: 'enabled',
    Header: 'Activar/Desactivar',
    headerLabel: 'Activar/Desactivar',
    CellComponent: VariantOffButtonCell,
  },
];
